import { FC } from 'react'

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { Divider, Drawer, IconButton, List, ListItem } from '@mui/material'
import { isMobile } from 'react-device-detect'

import { useAppStore } from '../../../Services/Store'
import { ToggleTypes } from '../../../Services/Types'
import { showGatedFeatures } from '../../../Services/Utils/ReactUtils'
import { useStyles } from '../../Main.Styles'
import { DeleteNotes, ExportButton, ImportButton } from '../ActionButtons'
import { ShareButton } from '../ActionButtons/ShareButton'
import ShareButtons from '../ShareButtons'
import MenuToggle from '../Toggles'
import { ColourPicker } from './ColorPicker'

export const AppMenuDrawer: FC<{
  open: boolean
  handleDrawerState(): void
}> = ({ open, handleDrawerState }) => {
  const { previewMode, darkMode, mdMode } = useAppStore(state => ({
    previewMode: state.settings.previewMode,
    darkMode: state.settings.darkMode,
    mdMode: state.settings.mdMode,
  }))

  const classes = useStyles(darkMode)({})

  const DrawerHeader: FC = () => (
    <div className={classes.drawerHeader}>
      <IconButton data-testid="close-menu-button" onClick={handleDrawerState}>
        <ChevronLeftIcon />
      </IconButton>
    </div>
  )

  const ImportListItem: FC = () => (
    <ListItem>
      <ImportButton />
    </ListItem>
  )

  const ExportListItem: FC = () => (
    <ListItem>
      <ExportButton />
    </ListItem>
  )

  const ShareList: FC = () => (
    <ListItem>
      <ShareButton />
    </ListItem>
  )

  const MenuItems: FC = () => (
    <List>
      {showGatedFeatures && <ShareList />}
      {showGatedFeatures && <ExportListItem />}
      {showGatedFeatures && <ImportListItem />}
      <ListItem>
        <DeleteNotes />
      </ListItem>
      <Divider style={{ marginTop: '0.75em' }} />
      <ColourPicker />
      <Divider style={{ marginTop: '0.75em' }} />
      <ListItem>
        <MenuToggle
          state={darkMode}
          dispatchType={ToggleTypes.DarkModeToggle}
          label="Dark Mode"
          qaId="dm-toggle"
        />
      </ListItem>
      <Divider />
      <ListItem>
        <MenuToggle
          state={mdMode}
          dispatchType={ToggleTypes.MarkDownToggle}
          label="Enable MarkDown"
          qaId="md-toggle"
        />
      </ListItem>
      {mdMode && !isMobile && (
        <div>
          <Divider />
          <ListItem>
            <MenuToggle
              state={previewMode}
              dispatchType={ToggleTypes.PreviewModeToggle}
              label="Always Show Preview"
              qaId="md-preview-toggle"
            />
          </ListItem>
        </div>
      )}
      <Divider />
    </List>
  )

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <DrawerHeader />
      <Divider />
      <MenuItems />
      <ShareButtons />
    </Drawer>
  )
}
